<template>
  <div class="page page__list page__has-bar help-page">
    <div class="page__bd">
      <search-list placeholder="搜索" />
      <p class="doc-items_title">文档分类</p>
      <div class="doc-items">
        <a
          href="javascript:;"
          v-for="item in project.items"
          class="doc-item"
          :key="item.id"
          @click="gotoView(item)"
        >
          <div class="doc-item__icon">
            <span class="iconfont" :class="item.article?'icon-file':'icon-folder'"></span>
          </div>
          <p class="doc-item__label">{{item.name}}</p>
        </a>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <router-link
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default feedback-btn"
        to="/help/feedback"
      >吐个槽</router-link>
    </div>
  </div>
</template>

<script>
import SearchList from "@/views/help/SearchList.vue";

export default {
  components: {
    SearchList
  },
  props: {
    projectCode: String
  },
  data() {
    return {
      project: {}
    };
  },
  created() {
    this.getProject();
  },
  methods: {
    getProject() {
      var me = this;
      me.$ajax({
        url: "/api/help/project/read",
        params: {
          code: me.projectCode
        }
      }).then(function(res) {
        if (res.success) {
          me.project = res.data;
        }
      });
    },
    gotoView(item) {
      var me = this;
      if (item.article) {
        me.$router.push("/doc/" + me.project.code + "/" + item.code);
      } else {
        me.$router.push({
          name: "DocProjectItems",
          params: {
            projectCode: me.project.code,
            projectItem: item
          }
        });
      }
    }
  }
};
</script>

<style>
.help-page {
  background: #fff;
}
.help-page .doc-items_title {
  padding: 10px;
  font-size: 17px;
}
.help-page .doc-items {
  display: flex;
  flex-wrap: wrap;
}
.help-page .doc-item {
  padding: 10px 0;
  flex: 0 0 33.33%;
  text-align: center;
}
.help-page .doc-item__icon .iconfont {
  font-size: 1.4em;
  color: var(--weui-BRAND);
}
.help-page .doc-item__label {
  font-size: 12px;
  color: #333333;
  letter-spacing: 1.6px;
}
.feedback-btn {
  font-weight: normal;
  font-size: 16px;
}
</style>